import { RuleCreateModel } from './rule-create-model';
import { RuleDomain } from './rule-domain';

export class RuleCreateModelWithDomainModel extends RuleCreateModel {
  domain: RuleDomain;
}
